<footer class="site-footer style-1" style="background-color: #a6dff136;">
    <div class="container">
        <div class="row d-flex justify-content-around footer-top">
            <div class="col-lg-4 col-md-4 col-sm-4 col-12 wow fadeInUp" data-wow-delay="0.3s">
                <div class="widget widget_services">
                    <div class="footer-logo logo-white mb-0">
                        <a href="home" class="">
                            <img src="assets/images/logo.webp" class="mb-3" alt="">
                        </a>
                    </div>
                    <p>
                        The origin of our publishing house came from a single book. Released in 2013, our first book,
                        'Ezhuthupizhai', became a great success with readers. That success turned our dream of creating
                        a publishing company into a reality. Today, that same name has become our identity.
                    </p>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-12 wow fadeInUp" data-wow-delay="0.3s">
                <div class="widget widget_services">
                    <h5 class="footer-title mb-2">Reach us</h5>
                    <ul class="widget-address mb-1">
                        <li>
                            <p class="lh-lg">
                                <strong>Address</strong> :
                                78/42, 3rd Main Rd, Gandhi Nagar, Adyar, Chennai, Tamil Nadu
                                600020
                            </p>
                        </li>
                    </ul>
                    <ul class="widget-address mb-1">
                        <li>
                            <a href="mailto:{{email}}" class="text-lowercase">
                                <i class="fas fa-envelope me-1"></i>
                                {{email}}
                            </a>
                        </li>
                        <li>
                            <a href="tel: +91 99627 00810">
                                <i class="fas fa-phone me-1"></i>
                                +91 99627 00810
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 col-sm-2 col-12 wow fadeInUp" data-wow-delay="0.3s">
                <div class="widget widget_services">
                    <h5 class="footer-title mb-2">Useful Links</h5>
                    <ul class="mb-2">
                        <li>
                            <a href="login">
                                <i class="fa-solid fa-hand-point-right me-1"></i>
                                Login
                            </a>
                        </li>
                        <li>
                            <a href="dashboard">
                                <i class="fa-solid fa-hand-point-right me-1"></i>
                                Track Order
                            </a>
                        </li>
                        <li>
                            <a href="dashboard">
                                <i class="fa-solid fa-hand-point-right me-1"></i>
                                Order History
                            </a>
                        </li>
                    </ul>
                    <h5 class="footer-title mb-2">Social Media</h5>
                    <div class="dz-social-icon style-1 justify-content-start">
                        <ul>
                            <li class="">
                                <a href="https://www.instagram.com/ezhuthupizhai_official/" target="_blank"
                                    class="border">
                                    <i class="fa-brands fa-instagram"></i>
                                </a>
                            </li>
                            <li class="">
                                <a href="https://www.facebook.com/ezhuthupizhai/" target="_blank" class="border">
                                    <i class="fa-brands fa-facebook-f"></i>
                                </a>
                            </li>
                            <li class="">
                                <a href="https://www.youtube.com/channel/UCRuwtbmWkxqdVnoY5PT9RDg/" target="_blank"
                                    class="border">
                                    <i class="fa-brands fa-youtube"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-12 wow fadeInUp" data-wow-delay="0.3s">
                <div class="widget widget_services">
                    <h5 class="footer-title mb-2">Location</h5>
                    <div>
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15549.670137213394!2d80.251374!3d13.009062!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a525d448b2e2fbd%3A0xad80cf358944f9e5!2sEZHUTHUPIZHAI!5e0!3m2!1sen!2sin!4v1752057987066!5m2!1sen!2sin"
                            width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"
                            referrerpolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-bottom py-0">
            <div class="row fb-inner pt-2 pb-2">
                <div class="col-12 col-lg-6">
                    <div class="text-start">
                        <p class="copyright-text">
                            © <span class="current-year">2025</span> Ezhuthupizhai. All Rights Reserved.</p>
                    </div>
                </div>
                <div class="col-12 col-lg-6 d-flex justify-content-end">
                    <ul class=""
                        style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 10px; align-items: center;justify-content: center;">
                        <li style="display: flex; align-items: center;">
                            <a href="terms-and-conditions" style="display: flex; align-items: center; gap: 5px;">
                                <i class="fas fa-circle" style="font-size: 8px;"></i>
                                <span>Terms & Conditions</span>
                            </a>
                        </li>
                        <li style="display: flex; align-items: center;">
                            <a href="privacy-policy" style="display: flex; align-items: center; gap: 5px;">
                                <i class="fas fa-circle" style="font-size: 8px;"></i>
                                <span>Privacy Policy</span>
                            </a>
                        </li>
                        <li style="display: flex; align-items: center;">
                            <a href="shipping-and-delivery" style="display: flex; align-items: center; gap: 5px;">
                                <i class="fas fa-circle" style="font-size: 8px;"></i>
                                <span>Shipping & Delivery</span>
                            </a>
                        </li>
                        <li style="display: flex; align-items: center;">
                            <a href="refund-policy" style="display: flex; align-items: center; gap: 5px;">
                                <i class="fas fa-circle" style="font-size: 8px;"></i>
                                <span>Refund Policy</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</footer>